export function track(...args) {
  if (self["gtag"]) {
    gtag(...args);
  }
}
